(() => {
  const endpoint = 'https://api.gigantistock.com/api/contact-form';
  const fallbackError = 'Something went wrong. Please try again or call 217-793-3300.';
  const networkError = 'Network error. Please try again or call 217-793-3300.';

  document.querySelectorAll('[data-sell-trade-form]').forEach((form) => {
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-form-error]');
    let isSubmitting = false;

    const showError = (message) => {
      error.textContent = message;
      error.hidden = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      error.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (isSubmitting) return;
      error.hidden = true;
      error.textContent = '';
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const data = new FormData(form);
      const model = String(data.get('model') || '').trim();
      const offer = String(data.get('offer') || '').trim();
      const notes = String(data.get('message') || '').trim();
      let message = `Sell Your Watch inquiry from gigantiwatches.com\n\nModel: ${model || 'Not provided'}\nAsking price: ${offer || 'Not provided'}`;
      if (notes) message += `\n\n${notes}`;

      const payload = {
        name: String(data.get('name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        phone: String(data.get('phone') || '').trim(),
        message,
        website: String(data.get('website') || '').trim(),
      };

      const buttonLabel = button.textContent;
      isSubmitting = true;
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = 'Sending…';

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
          showError(typeof body?.error === 'string' && body.error ? body.error : fallbackError);
          return;
        }
        if (!window.GigantiLeads?.confirm(form, body, 'sell_trade')) {
          showError('We could not confirm your request. Please call 217-793-3300 before submitting again.');
          return;
        }

        const success = document.createElement('div');
        success.className = 'journey-form__success';
        success.setAttribute('role', 'status');
        success.setAttribute('tabindex', '-1');

        const heading = document.createElement('h3');
        heading.textContent = 'Thanks, we got it.';
        const copy = document.createElement('p');
        copy.textContent = 'We typically respond within 24 hours. For anything urgent, call 217-793-3300 and ask for Josh or Cara.';
        success.append(heading, copy);
        form.replaceChildren(success);
        success.focus();
      } catch {
        showError(networkError);
      } finally {
        isSubmitting = false;
        form.removeAttribute('aria-busy');
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = buttonLabel;
        }
      }
    });
  });
})();
